import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatEnum } from '../../enum/date-format.enum';
import { DateRangeEnum } from '../../enum/date-range.enum';
import { AlertifyService } from '../../services/core/alertify.service';
import { DateUtils } from '../../utils/date.utils';


@Component({
  selector: 'app-data-range-select-modal',
  templateUrl: './data-range-select-modal.component.html',
  styleUrls: ['./data-range-select-modal.component.css']
})
export class DataRangeSelectModalComponent implements OnInit {
  @Input() hideTomorrow = false;
  @Input() hidePast = false;
  @Input() startDate = new Date();
  @Input() endDate = new Date();
  @Input() dateRange: string;
  @Input() dateTitle: string;
  isDateActive: Boolean;

  dateTitleTemp: string;
  dateRangeEnum = DateRangeEnum;
  dateFormatEnum = DateFormatEnum;

  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  months: number[] = [];
  years: number[] = [];
  numOfMonths: number
  isCustomSelected: Boolean = false;

  constructor(private translate: TranslateService,
    private alertifyService: AlertifyService) { }

  ngOnInit(): void {
    if (this.hideTomorrow) {
      for (let i = 0; i < 13; i++) {
        // Ay eklemek için array'e indeksleme yaparak eriş
        this.months.push(-1 * i);
      }
    }
    else if (this.hidePast) {
      for (let i = 0; i < 13; i++) {
        // Ay eklemek için array'e indeksleme yaparak eriş
        this.months.push(i);
      }
    }
    else {

      // for (let i = 3; i > 0; i--) {
      //   // Ay eklemek için array'e indeksleme yaparak eriş
      //   this.months.push(i);
      // }
      for (let i = 0; i < 13; i++) {
        // Ay eklemek için array'e indeksleme yaparak eriş
        this.months.push(-1 * i);
      }

    }

    // Son 5 yılı ekle
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.years.push(currentYear - i);
    }

  }

  selectRange(range: string): void {
    this.dateRange = range;
    if ((this.dateRange != this.dateRangeEnum.CUSTOM)) {
      let returnValue = DateUtils.getStartEndDate(this.dateRange);
      this.startDate = returnValue.startDate;
      this.endDate = returnValue.endDate;
      this.isDateActive = returnValue.isDateActive;
      this.dateTitleTemp = this.translate.instant('dateRangeEnumValue.' + returnValue.title);
      this.apply();
    }
    else {

      this.dateTitleTemp = "";
      this.isDateActive = true;
      this.startDate = DateUtils.getToday();
      this.endDate = DateUtils.getToday();

      this.isCustomSelected = true;
    }
  }

  clearCustom() {
    this.isCustomSelected = false;
  }

  apply() {
    if (this.dateRange == this.dateRangeEnum.CUSTOM && DateUtils.isAfter(this.startDate, this.endDate)) {
      this.alertifyService.error(this.translate.instant("message.warning.the-start-date-shouldnt-be-after-than-the-end-date"));
      return;

    }
    this.setDate();

    this.passEntry.emit({
      isInitial: false,
      startDate: this.startDate,
      endDate: this.endDate,
      isDateActive: this.isDateActive,
      dateTitle: this.dateTitle,
      dateRange: this.dateRange

    });
  }

  setDate() {
    DateUtils.clearTime(this.startDate);
    DateUtils.clearTime(this.endDate);
    this.dateTitle = this.dateTitleTemp;
  }
  selectMonth(value) {
    this.startDate = DateUtils.firstMonthDay(DateUtils.addMonths(DateUtils.getToday(), value));
    this.endDate = DateUtils.lastMonthDay(DateUtils.addMonths(DateUtils.getToday(), value));
    this.dateTitleTemp = this.getMonthName(value);
    this.isDateActive = true;
    this.dateRange = this.dateRangeEnum.CUSTOM;
    this.apply();
  }

  getMonthName(value: number) {
    let date = DateUtils.addMonths(DateUtils.getToday(), value);
    let year = date.getFullYear();
    let month = this.translate.instant('primeng.monthNames.' + date.getMonth() + '');
    return month + " " + year;
  }

  selectYear(year: number) {
    this.startDate = new Date(year, 0, 1); // Yılın ilk günü
    this.endDate = new Date(year, 11, 31); // Yılın son günü
    this.dateTitleTemp = year.toString();
    this.isDateActive = true;
    this.dateRange = this.dateRangeEnum.CUSTOM;
    this.apply();
  }

  close() {
    this.passEntry.emit();
  }
}
